import { render, staticRenderFns } from "./UsersBody.vue?vue&type=template&id=fd165132&scoped=true&"
import script from "./UsersBody.vue?vue&type=script&lang=js&"
export * from "./UsersBody.vue?vue&type=script&lang=js&"
import style0 from "./UsersBody.vue?vue&type=style&index=0&id=fd165132&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd165132",
  null
  
)

export default component.exports